var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandColoredHaskell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.1091L6.73934 12.0001L2 4.89111H5.50711L10.2464 12.0001L5.50711 19.1091H2Z",
    fill: "#453A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73934 19.1091L11.4787 12.0001L6.73934 4.89111H10.2464L19.7251 19.0143H16.218L13.2796 14.5594L10.3412 19.0143H6.73934V19.1091Z",
    fill: "#5E5086"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1137 14.9385L16.5024 12.5688H22V14.9385H18.1137ZM15.7441 11.4314L14.1327 9.06173H22V11.4314H15.7441Z",
    fill: "#8F4E8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandColoredHaskell);
export default __webpack_public_path__ + "static/media/brand_colored_haskell.1cd18a8085b52108d29149d9b67cc7a2.svg";
export { ForwardRef as ReactComponent };